// @ts-ignore
import { FiqlQuery } from './fiql-query';
import { serializeTypedFiqlQuery } from './serialize-typed-fiql-query';

export function serializeFiqlQuery(fiqlQuery: FiqlQuery): string {
  return serializeTypedFiqlQuery(fiqlQuery as any) || ''; // TODO kdraba: find a way to make this type safe, or even better, make this serializer obsolete
}
